import React, { useState } from "react";
import "../../style/AlbumOfTheDay.css"
import { NavLink } from "react-router";

const AlbumOfTheDay = ({
  album,
  group,
  className,
}) => {
  const [currentTime, setCurrentTime] = useState(new Date())


  const differenceDay = dayDiffIgnoreYear(album?.dateAlbum, currentTime);
  const differenceYear = yearDiffOnly(currentTime, album?.dateAlbum);
  return (
    <div className={`albumOfTheDay_div ${className}`}>
      <img className="albumOfTheDay_img" src={album?.imageUrl} alt="" />
      <div className="albumOfTheDay_description">
        <h1 className="albumOfTheDay_title">Album du jour :</h1>
        <h2 className="albumOfTheDay_titleAlbum">{album?.albumTitle}</h2>
        <h2 className="albumOfTheDay_titleGroup">{group?.name}</h2>
        {/* <h2 className="albumOfTheDay_dateAlbum">{`${album?.fullDate}`}</h2> */}
        <h2 className="albumOfTheDay_dateExplication">
          {`
            ${differenceDay===0?`Cet album fête aujourd'hui, `:""}
            ${differenceDay>0?`Cet album fête dans ${Math.abs(differenceDay)} jour${differenceDay>1?"s":""}, `:""}
            ${differenceDay<0?`Cet album a fêté il y a ${Math.abs(differenceDay)} jour${differenceDay<-1?"s":""}, `:""}
            ses ${Math.abs(differenceYear)} ans.
          `}
        </h2>
      </div>
    </div>
  )
  
};
AlbumOfTheDay.propTypes = {
};

/**
 * 
 * @param {*} dateA a date to compare
 * @param {*} dateB a another date to compare
 * @returns the difference in day from the first date to the second
 */
function dayDiffIgnoreYear(dateA, dateB) {
  const yearRef = 2001; // année non bissextile
  const a = new Date(yearRef, dateA?.getMonth(), dateA?.getDate());
  const b = new Date(yearRef, dateB?.getMonth(), dateB?.getDate());
  // la diff en ms
  const diffTime = a - b; 
  // on met en jours
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
}

function yearDiffOnly(dateA, dateB) {
  return Math.abs(dateA?.getFullYear() - dateB?.getFullYear());
}

export default AlbumOfTheDay;
